module.exports = "/images/hr.svg?684b1c89a8825762282a4ded821cd863";